'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.percy = undefined;

var _percy2 = require('./percy');

var _percy3 = _interopRequireDefault(_percy2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.percy = _percy3.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@percy/react-percy-test-framework/lib/interfaces/index.js
// module id = 476
// module chunks = 1